import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'MAINTENANCES',
    itemActionName: 'MAINTENANCE',
});
